import React from 'react';

import {message} from 'antd';
import {observable, computed, action} from "mobx";
import http from 'libs/http';
import lodash from 'lodash'

// the hook
import {useTranslation} from 'react-i18next';

class Store {
  @observable records = [];
  @observable quoteRecords = [];
  @observable handleRecord = {};
  @observable isFetching = false;
  @observable handleId = '';
  @observable addressId = ''
  @observable invoiceId = ''
  @observable poNum = ''
  @observable remark = ''
  @observable spp = {}
  @observable spq = {}
  @observable page = 1
  @observable quotePage = 1
  @observable pageSize = 10
  @observable quotePageSize = 10
  @observable pageTotal = 10
  @observable quotePageTotal = 10

  // // 求购单过滤
  // @computed get filterRecords() {
  //   return this.records.filter(v => {
  //     let isOK = true
  //     if (isOK && this.spp.name) { // 产品名称
  //       isOK = isOK && (v.goods.filter(item => item.name.indexOf(this.spp.name) !== -1).length > 0)
  //     }
  //     if (isOK && this.spp.purchase_sn) { // 求购编号
  //       isOK = isOK && ((v.sn + '').indexOf(this.spp.purchase_sn) !== -1)
  //     }
  //     if (isOK && this.spp.extra_sn) { // 项目编号
  //       isOK = isOK && (v.goods.filter(item => item.extra_sn && (item.extra_sn.indexOf(this.spp.extra_sn) !== -1)).length > 0)
  //     }
  //     if (isOK && this.spp.factory_code) { // 货号
  //       isOK = isOK && (v.goods.filter(item => item.factory_code.indexOf(this.spp.factory_code) !== -1).length > 0)
  //     }
  //     if (isOK && this.spp.brand) { // 品牌
  //       isOK = isOK && (v.goods.filter(item => item.brand.indexOf(this.spp.brand) !== -1).length > 0)
  //     }
  //     if (isOK && this.spp.center_sn) { // 中心号
  //       isOK = isOK && true
  //     }

  //     return isOK
  //   })
  // }

  // // 报价单过滤
  // @computed get filterQuoteRecords() {
  //   return this.quoteRecords.filter(v => {
  //     let isOK = true
  //     if (isOK && this.spq.name) { // 产品名称
  //       isOK = isOK && (v.goods.filter(item => item.name.indexOf(this.spq.name) !== -1).length > 0)
  //     }
  //     if (isOK && this.spq.quote_sn) { // 报价单编号
  //       isOK = isOK && ((v.sn + '').indexOf(this.spq.quote_sn) !== -1)
  //     }
  //     if (isOK && this.spq.extra_sn) { // 项目编号
  //       isOK = isOK && (v.goods.filter(item => item.extra_sn && (item.extra_sn.indexOf(this.spq.extra_sn) !== -1)).length > 0)
  //     }
  //     if (isOK && this.spq.factory_code) { // 货号
  //       isOK = isOK && (v.goods.filter(item => item.factory_code.indexOf(this.spq.factory_code) !== -1).length > 0)
  //     }
  //     if (isOK && this.spq.brand) { // 品牌
  //       isOK = isOK && (v.goods.filter(item => item.brand.indexOf(this.spq.brand) !== -1).length > 0)
  //     }
  //     if (isOK && this.spq.center_sn) { // 中心号
  //       isOK = isOK && true
  //     }

  //     return isOK
  //   })
  // }

  //获取求购记录
  fetchRecords = () => {
    this.isFetching = true;
    let query = this.spp;
    http.post('/javaApi/front/inquiry/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize,
      param: query 
    })
      .then(action('a', res => {
        console.log(res);
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.isFetching = false))
  };

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    // localStorage.setItem('orderPageSize',size);
    this.fetchRecords()
}
  quotePageChange = (page, size) => {
    this.quoteRecords = []
    this.quotePage = page;
    this.quotePageSize = size;
    // localStorage.setItem('orderPageSize',size);
    this.fetchQuoteRecords()
}

  // 求购记录：更新已读状态
  updateReadStatus = (type) => {
    return http.patch('/api/front/inquiry/', {status: type})
      .then(res => {
        this.fetchRecords()
      })
  }

  //获取报价单
  fetchQuoteRecords = () => {
    this.isFetching = true;
    let query = this.spq;
    http.post('/javaApi/front/quote/list',{ 
      pageNo: this.quotePage,
      pageSize: this.quotePageSize,
      param: query 
    })
      .then(action('a', res => {
        console.log(res);
        this.quoteRecords = res.data.result.data
        this.quotePageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.isFetching = false))
  };

  //合并报价单
  mergeQuoteRecords = (ids) => {
    return http.post('/api/front/quote/', {ids: ids})
      .then(res => this.fetchQuoteRecords())
  }

  // 下单
  checkOrder = (data) => {
    return http.put('/api/front/order/', data)
      .then(res => {
        this.orderId = res
        this.fetchQuoteRecords()
        message.success('下单成功！')
      })
  }


}

export default new Store()

// 报价单
// created_at: "2020-10-29 14:05:56"
// customer_id: 1
// customer_name: "张三丰"
// id: 4
// inquiry_id: null
// is_agent: [true]
// remarks: null
// sn: 103905011556
// status: "10"
// status_alias: "报价成功"
// total_price: 170504
// type: "1"
// goods: [{id: 5, product_id: 6, name: "2-8℃药品保存箱", brand: "澳柯玛", brand_code: "QLC", factory_code: "YC-80",…}]

// brand: "长沙迪普美"
// brand_code: "QLC"
// created_at: "2020-10-29 05:55:03"
// duration: null
// extra_sn: "2311"
// factory_code: "VP1"
// formats: "套"
// goods_id: 4
// id: 4
// material_code: "QLC*VP1*MDP2"
// name: "输液泵"
// number: 5
// period: "7天"
// price: 80
// product_id: 25
// quote_id: 3
// supplier_code: "MDP2"
// type: "2"


// 求购单
// created_at: "2020-10-29 09:04:16"
// customer_id: 1
// customer_name: "张三丰"
// id: 4
// sn: 103906021256
// status: "0"
// status_alias: "待报价"
// total_price: 0
// goods: [{id: 7, inquiry_id: 4, product_id: 25, name: "", brand: null, factory_code: "", formats: null,…},…]

// brand: "苏宏"
// duration: null
// extra_sn: null
// factory_code: "RGZ-120"
// formats: "套"
// id: 15
// inquiry_id: 7
// name: "机械身高体重秤"
// number: 1
// period: null
// price: null
// product_id: 22
// type: "1"
// type_alias: "购买"
